import React from 'react'
import './testimonials.css'

const Testimonials = () => {
  return (
    <div></div>
  )
}

export default Testimonials